import { createContext, useContext } from 'react'

export interface ChatTurnCompletionValue {
  /**
   * Id of the assistant message whose turn most recently finished streaming.
   * Changes once per turn, so surfaces that only care about "something new
   * arrived" can subscribe without taking on per-chunk stream churn.
   */
  lastCompletedTurnId: string | undefined
}

const DEFAULT_CHAT_TURN_COMPLETION: ChatTurnCompletionValue = {
  lastCompletedTurnId: undefined,
}

/**
 * Defaults to an inert value so surfaces that mount the mobile shell without the trip
 * planner provider (visual fixtures, isolated tests) still render.
 */
export const ChatTurnCompletionContext = createContext<ChatTurnCompletionValue>(
  DEFAULT_CHAT_TURN_COMPLETION,
)

export function useChatTurnCompletion(): ChatTurnCompletionValue {
  return useContext(ChatTurnCompletionContext)
}
